import React from 'react'
import {Button} from "antd";

const EditPurchase = ({record}) => {

    return(
        <React.Fragment>
            <Button
                type={'link'}
            >
                <a target={'_blank'}  rel="noopener noreferrer" href={`purchase/edit/${record.id}`}>Güncelle</a>
            </Button>
        </React.Fragment>
    )
}
export default EditPurchase